import api from '@/api/axios'
import type { IProfileClientUsage } from '@/shared/interfaces/profile.interface'
import { EEikoApi } from '@/shared/enum/eiko-api.enum'
import type { IBalance } from '@/shared/interfaces/balance.interface'
import type { ISeigyoConfig } from '@/shared/interfaces/seigyo-config'

export const fetchProfileUserBuyPackage = async (): Promise<string> => {
  const { data } = await api.get<string>(`${EEikoApi.PROFILE}/Profile/BuyPackage`)
  return data
}

export const fetchProfileUserSendPackage = async (msisdn: string): Promise<string> => {
  const { data } = await api.post<string>(`${EEikoApi.PROFILE}/Profile/SendPackage`, msisdn)
  return data
}

export const fetchMicrocreditLevel = async (): Promise<string> => {
  const { data } = await api.get<string>(`${EEikoApi.PROFILE}/ClaroProfile/MicroCreditLevel`)
  return data
}

export const fetchBalance = async (): Promise<IBalance> => {
  const { data } = await api.get<IBalance>(`${EEikoApi.PROFILE}/Profile/Balance`)
  return data
}

export const fetchClientUsage = async (): Promise<IProfileClientUsage> => {
  const { data } = await api.get<IProfileClientUsage>(`${EEikoApi.PROFILE}/Profile/ClientUsage`)
  return data
}

export const fetchMPCMaintenanceConfig = async (mpcUrl: string): Promise<ISeigyoConfig> => {
  const { data } = await api.get(`${mpcUrl}/factura/FrontEndConfiguration.json`)
  return data
}
